import { createAction } from '@reduxjs/toolkit';

export const startLoadingApp = createAction('startLoadingApp');
export const stopLoadingApp = createAction('stopLoadingApp');
